module.exports = __webpack_public_path__ + "static/media/cityvelocity.568ee22c.png";